<div class="orderForm  position-relative">
    <div class="container-fluid orderInfoForm thin-scroll">
        <!-- <div
            class="header p-2  d-flex align-items-center  justify-content-end"
        >


   
     
       
 
        </div> -->
        <!-- <hr class="my-2" /> -->
        <div class="row mb-3">
            <h6 class="col-6 mt-4 pl-3 mb-3" ><span class="headertxt previewTitle ml-md-2 white-space-nowrap" style="white-space: nowrap;"> Entered By :  <span style="color: #888;
               
                font-size: 14px; margin-left: 5px; ">{{fullName}}</span></span></h6>
            <div class="col-6"    *ngIf="!createOrEditorderInfo &&  !showSaveBtn &&  canChange">
                <button
             
                (click)="showEditMode()"
                class="previewbtn text-center btn float-right"
            >
            
            
            <img src="../../../../../assets/shoppingCart/edit.png"
            class="imgIcon" style="position: relative;right: 0 !important;bottom: 0 !important;"/>
            <span class="mx-1 text-white"> Edit</span>

            </button>
            </div>
            <div *ngIf="createOrEditorderInfo" class="formGroup  col-md-6 col-12 pl-md-0 " style="padding-right: 13px;padding-left: 4px !important;">
                <label class="label pl-1">Reference #</label>
                <input
                
                    type="text"
                    placeholder="Reference Number"
                    class="form-control "
                    style="    width: 95% !important;
    margin-left: 3px;"
                    [(ngModel)]="reference"
                />
             
           
            </div>
        </div>
        <hr   *ngIf="!createOrEditorderInfo " class="my-2" />

        <div class="pr-3">
            <app-contact
            class="w-100"
            [isCreateOrEdit]="createOrEditorderInfo"
                [activeTab]="activeTab"
                [currentTab]="currentTab"
                [appTransactionsForViewDto]="appTransactionsForViewDto"
                (formValidityChanged)="isContactFormValid($event)"
                (updateAppTransactionsForViewDto)="onUpdateAppTransactionsForViewDto($event)"
                [showDepartment]="activeTab == shoppingCartoccordionTabs.BuyerContactInfo"
            ></app-contact>

            <div class="row pl-2">
                <div *ngIf="!createOrEditorderInfo" class="col-md-6 col-12 mt-2">
                 
                        <div
                            class="d-flex align-items-center   w-100"
                        >
                            <h6 class="previewTitle  m-0 p-0 col-6 my-2">Reference Number:</h6>
                            <p class="previewValue  m-0 p-0 col-6 my-2">
                                {{ appTransactionsForViewDto?.reference }}
                            </p>
                        </div>
                  
</div>
                <!-- classification -->
                <app-codes *ngIf="showAppCodes &&  !(classification?.id>0)"
                    [objectType]="entityObjectClassificationType"
                    [editMode]=false
                    (getCodeValue)="getClassCodeValue($event)" ></app-codes>

                    <app-codes *ngIf="showAppCodes &&  classification?.id>0"
                     [objectType]="entityObjectClassificationType"
                     [editMode]=true
                     [code]="classification?.code"
                     (getCodeValue)="getClassCodeValue($event)" ></app-codes>
                <div class="col-md-12 mt-2">
                    <div *ngIf="createOrEditorderInfo" class="d-flex flex-column">
                        <div class="d-flex"> <label class="label pt-2 mr-2 ">Classifications</label> 
                             <div *ngIf="allClassFilteredRecords.length == 0 &&  appTransactionsForViewDto?.entityClassifications?.length == 0" (click)="showClassBtn = true ; toggleAppCodes() " class="d-flex p-y-1 px-4 rounded  cat"> <span class="mr-2">+</span> Add New Classification</div>
                <div class="d-flex">

                    <div class="d-flex" *ngIf="showSelectedClass || appTransactionsForViewDto?.entityClassifications?.length != 0
                    ">
                        <div
                        class="previewValue classificationsValues m-0 p-0  d-flex justify-content-between position-relative"
                        *ngFor="let item of selectedClassificationsShow; index as i"
                        [ngClass]="{ 'dimmed': tempDeselectedClassification.includes(item) }"
                      >
                        <span class="mt-2">{{ item }}</span>
                        <a class="clear-icon" (click)="deSelectClass(item, i)">
                          <i class="fa fa-1x fa-times fa-1x"></i>
                        </a>
                        
                        <a *ngIf="tempDeselectedClassification.includes(item)" style="background-color: #777;" class="clear-icon-d" >
                            <i class="fa fa-1x fa-times fa-1x"></i>
                        </a>
                      </div>
                    
                    </div>
                    
                      
                    <div *ngIf="allClassFilteredRecords.length != 0 &&  !showExistClass " (click)="showExistClass = true;showClassBtn= false" class="d-flex p-y-1 px-4 rounded  cat"> <span class="mr-2">+</span> Add Classification</div>
                    </div>
                    
                    <div *ngIf="allClassFilteredRecords.length == 0 &&  appTransactionsForViewDto?.entityClassifications?.length != 0" (click)="showClassBtn = true ; toggleAppCodes() " class="d-flex p-y-1 px-4 rounded  cat"> <span class="mr-2">+</span> Add New Classification</div>

                   
                </div>







<div class="d-flex mt-2" *ngIf="showClassBtn ">
    <div  class="formGroup  col-8">
      
        <input
        
            type="text"
            placeholder="classification"
            class="form-control "
            style="width: 95% !important;"
            [(ngModel)]="classification.name"
            
        />
     
   
    </div>
    <button
   
 
   (click)="saveClass(classification);hideClassBtn =true;showClassBtn = false"
    class="previewbtn text-center btn "
>
    Save

</button>
<button
(click)="cancelClass();hideClassBtn =true;showExistClass = true;showClassBtn = false;
"
class="cancelbtn text-center btn "
>
Cancel

</button>
 </div>
                   
<!-- </div>       -->
<div class="d-flex" *ngIf=" allClassFilteredRecords.length != 0">
 





<div *ngIf="showExistClass"  class="flex justify-content-center treeSel"    >
    <p-treeSelect 
    class="w-full md:w-20rem"
    containerStyleClass="w-full"
    [(ngModel)]="selectedClassification"
    [options]="allClassFilteredRecords"
    display="chip"
    selectionMode="checkbox"
    placeholder="Select Item"
    [filter]="true"
    filterPlaceholder="Search Items"
    (onNodeSelect)="onNodeSelect($event)"
    (onNodeUnselect)="onNodeUnselect($event)"
 
>
    <ng-template pTemplate="default">
        <div class="header p-2 d-flex align-items-center justify-content-between">
            <div>
                <input type="checkbox" (change)="toggleSelectAll()" /> Select All
            </div>
            <button class="btn btn-link" (click)="collapseAll()">Collapse All</button>
        </div>
    </ng-template>
    
    <ng-template let-node pTemplate="default">
        <div (click)="onLabelClick($event)" class="d-flex justify-content-between">
            <span style="margin-top: 8px;">{{ node.label }}</span>
            <div class="treenode-action">
                <div class="btn-group dropdown" dropdown container="body" placement="bottom right">
                    <button title="actions" class="dropdown-toggle btn btn-sm" aria-controls="dropdown-alignment" dropdownToggle>
                        <div class="three-dots"></div>
                    </button>
                    <ul id="dropdown-alignment" class="dropdown-menu dropdown-action-btn dropdown-menu-right" *dropdownMenu>
                        <li><a (click)="addAsNewChildClass(node);showClassBtn = true;showExistClass= false"> <svg class="mx-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clip-path="url(#clip0_83_2876)">
                              <path d="M6.99984 13.3332C6.99984 13.5984 7.10519 13.8527 7.29273 14.0403C7.48027 14.2278 7.73462 14.3332 7.99984 14.3332C8.26505 14.3332 8.51941 14.2278 8.70694 14.0403C8.89448 13.8527 8.99984 13.5984 8.99984 13.3332V8.99984H13.3332C13.5984 8.99984 13.8527 8.89448 14.0403 8.70694C14.2278 8.51941 14.3332 8.26505 14.3332 7.99984C14.3332 7.73462 14.2278 7.48027 14.0403 7.29273C13.8527 7.10519 13.5984 6.99984 13.3332 6.99984H8.99984V2.6665C8.99984 2.40129 8.89448 2.14693 8.70694 1.9594C8.51941 1.77186 8.26505 1.6665 7.99984 1.6665C7.73462 1.6665 7.48027 1.77186 7.29273 1.9594C7.10519 2.14693 6.99984 2.40129 6.99984 2.6665V6.99984H2.6665C2.40129 6.99984 2.14693 7.10519 1.9594 7.29273C1.77186 7.48027 1.6665 7.73462 1.6665 7.99984C1.6665 8.26505 1.77186 8.51941 1.9594 8.70694C2.14693 8.89448 2.40129 8.99984 2.6665 8.99984H6.99984V13.3332Z" fill="#777777"/>
                            </g>
                            <defs>
                              <clipPath id="clip0_83_2876">
                                <rect width="16" height="16" fill="white"/>
                              </clipPath>
                            </defs>
                          </svg>{{ "AddSubClassification" | localize }}</a></li>
                        <li><a (click)="EditClass(node);showClassBtn = true;showExistClass= false">   <svg class="mx-2" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                            <g clip-path="url(#clip0_83_2871)">
                              <path d="M8.2749 2.66666H5.4749C4.3548 2.66666 3.79474 2.66666 3.36692 2.88464C2.9906 3.07639 2.68464 3.38235 2.49289 3.75867C2.2749 4.1865 2.2749 4.74655 2.2749 5.86666V11.4667C2.2749 12.5868 2.2749 13.1468 2.49289 13.5746C2.68464 13.951 2.9906 14.2569 3.36692 14.4487C3.79474 14.6667 4.3548 14.6667 5.4749 14.6667H11.0749C12.195 14.6667 12.7551 14.6667 13.1829 14.4487C13.5592 14.2569 13.8652 13.951 14.0569 13.5746C14.2749 13.1468 14.2749 12.5868 14.2749 11.4667V8.66666M6.27488 10.6667H7.39125C7.71737 10.6667 7.88043 10.6667 8.03388 10.6298C8.16993 10.5972 8.29999 10.5433 8.41928 10.4702C8.55384 10.3877 8.66914 10.2724 8.89974 10.0418L15.2749 3.66666C15.8272 3.11437 15.8272 2.21894 15.2749 1.66666C14.7226 1.11437 13.8272 1.11437 13.2749 1.66665L6.89973 8.04182C6.66912 8.27242 6.55382 8.38772 6.47137 8.52228C6.39826 8.64157 6.34439 8.77163 6.31172 8.90768C6.27488 9.06113 6.27488 9.22419 6.27488 9.55031V10.6667Z" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                              <clipPath id="clip0_83_2871">
                                <rect width="16" height="16" fill="white" transform="translate(0.941406)"/>
                              </clipPath>
                            </defs>
                          </svg> {{ "Edit" | localize }}</a></li>
                        <li><a (click)="deleteClass(node)"> <svg class="mx-2" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M5.40909 2.33333H8.59091C8.59091 1.94656 8.4233 1.57563 8.12494 1.30214C7.82659 1.02865 7.42194 0.875 7 0.875C6.57806 0.875 6.17341 1.02865 5.87506 1.30214C5.5767 1.57563 5.40909 1.94656 5.40909 2.33333ZM4.45455 2.33333C4.45455 1.71449 4.72273 1.121 5.20009 0.683417C5.67746 0.245833 6.3249 0 7 0C7.6751 0 8.32254 0.245833 8.79991 0.683417C9.27727 1.121 9.54545 1.71449 9.54545 2.33333H13.5227C13.6493 2.33333 13.7707 2.37943 13.8602 2.46147C13.9497 2.54352 14 2.6548 14 2.77083C14 2.88687 13.9497 2.99815 13.8602 3.08019C13.7707 3.16224 13.6493 3.20833 13.5227 3.20833H12.6891L11.9146 11.7268C11.8583 12.3464 11.55 12.9241 11.0508 13.3452C10.5516 13.7662 9.89801 14 9.21964 14H4.78036C4.10199 14 3.44842 13.7662 2.94923 13.3452C2.45004 12.9241 2.14171 12.3464 2.08536 11.7268L1.31091 3.20833H0.477273C0.350692 3.20833 0.229296 3.16224 0.13979 3.08019C0.0502839 2.99815 0 2.88687 0 2.77083C0 2.6548 0.0502839 2.54352 0.13979 2.46147C0.229296 2.37943 0.350692 2.33333 0.477273 2.33333H4.45455ZM6.04545 5.6875C6.04545 5.57147 5.99517 5.46019 5.90566 5.37814C5.81616 5.29609 5.69476 5.25 5.56818 5.25C5.4416 5.25 5.32021 5.29609 5.2307 5.37814C5.14119 5.46019 5.09091 5.57147 5.09091 5.6875V10.6458C5.09091 10.7619 5.14119 10.8731 5.2307 10.9552C5.32021 11.0372 5.4416 11.0833 5.56818 11.0833C5.69476 11.0833 5.81616 11.0372 5.90566 10.9552C5.99517 10.8731 6.04545 10.7619 6.04545 10.6458V5.6875ZM8.43182 5.25C8.30524 5.25 8.18384 5.29609 8.09434 5.37814C8.00483 5.46019 7.95455 5.57147 7.95455 5.6875V10.6458C7.95455 10.7619 8.00483 10.8731 8.09434 10.9552C8.18384 11.0372 8.30524 11.0833 8.43182 11.0833C8.5584 11.0833 8.6798 11.0372 8.7693 10.9552C8.85881 10.8731 8.90909 10.7619 8.90909 10.6458V5.6875C8.90909 5.57147 8.85881 5.46019 8.7693 5.37814C8.6798 5.29609 8.5584 5.25 8.43182 5.25Z" fill="#777777"/>
                          </svg> {{ "Delete" | localize }}</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template let-last pTemplate="footer">
        <div class="d-flex justify-content-end p-2">
            <button class="btn bgPurple" (click)="saveClassSelection()">Save</button>
            <button class="btn btn-secondary" (click)="cancelClassSelection()">Cancel</button>
        </div>
    </ng-template>
</p-treeSelect>


</div>

                  
                        <button *ngIf=" showExistClass" (click)="showClassBtn = true;showExistClass= false ; toggleAppCodes()" class="d-flex p-y-1 px-4 rounded cat"> <span class="mr-2">+</span> Add New Classification</button>
                    </div>
                    </div>
                    <div *ngIf="!createOrEditorderInfo">
                        <div
                            class="align-items-center big-scroll categoriesClassificationsContainer   d-flex  row   w-100 "
                        >
                            <h6 class="previewTitle  m-0 p-0 pr-2 ">
                                Classifications :
                            </h6>
                            <p
                                class="previewValue classificationsValues  m-0 p-0  my-2"
                                *ngFor="
                                    let item of appTransactionsForViewDto?.entityClassificationsNames?.items
                                "
                            >
                                {{ item}}
                            </p>
                            <p
                                class="previewValue m-0 p-0 col-6 my-2"
                                *ngIf="
                             !appTransactionsForViewDto?.entityClassificationsNames  ||  appTransactionsForViewDto?.entityClassificationsNames?.items
                                    ?.length == 0
                            "
                            >
                                -
                            </p>
                        </div>
                    </div>
                </div>
                <!-- classification -->

                <!-- categories -->
                <app-codes *ngIf="showAppCatCodes && !(category?.id>0)"
                    [objectType]="entityObjectType"
                    [editMode]=false
                    (getCodeValue)="getCodeValue($event)" ></app-codes>

                <app-codes *ngIf="showAppCatCodes && category?.id>0"
                     [objectType]="entityObjectType"
                     [editMode]=true
                     [code]="category?.code"
                     (getCodeValue)="getCodeValue($event)" ></app-codes>
                <div class="col-md-12 mt-2">
                    <div *ngIf="createOrEditorderInfo" class="d-flex flex-column">
                        <div class="d-flex" style="gap: 50px;"> <label class="label pt-2 mr-2 ">Categories</label>  <div *ngIf="filteredRecords.length == 0  &&  appTransactionsForViewDto?.entityCategories?.length == 0" (click)="showCatBtn = true; toggleAppCatCodes()"  class="d-flex p-y-1 px-4 rounded  cat"> <span class="mr-2">+</span> Add New Categories</div>
<div class="d-flex">


    <div class="d-flex" *ngIf="showSelectedCat || appTransactionsForViewDto?.entityCategories?.length != 0">
        <div
            class="previewValue classificationsValues m-0 p-0  d-flex justify-content-between position-relative"
            *ngFor="let item of selectedCategoriesShow; index as i"
            [ngClass]="{ 'dimmed': tempDeselectedCategories.includes(item) }"
        >
            <span class="mt-2">{{ item }}</span>
            <a class="clear-icon" (click)="deSelectCat(item, i)">
                <i class="fa fa-1x fa-times fa-1x"></i>
            </a>

            <a *ngIf="tempDeselectedCategories.includes(item)" style="background-color: #777;" class="clear-icon-d" >
                <i class="fa fa-1x fa-times fa-1x"></i>
            </a>
        </div>
    

    
    </div>


    
    <div *ngIf="filteredRecords.length != 0 && !showExistCat" (click)="showExistCat = true;showCatBtn= false" class="d-flex p-y-1 px-4 rounded cat">
        <span class="mr-2">+</span> Add Categories
    </div>
    <div *ngIf="filteredRecords.length == 0  &&  appTransactionsForViewDto?.entityCategories?.length != 0" (click)="showCatBtn = true; toggleAppCatCodes()"  class="d-flex p-y-1 px-4 rounded  cat"> <span class="mr-2">+</span> Add New Categories</div>
</div>
                      
                        

                          
                        </div> 
                          
                        <div class="d-flex mt-2" *ngIf="(showCatBtn ) ">
                            <div  class="formGroup  col-8">
                              
                                <input
                                
                                    type="text"
                                    placeholder="Category"
                                    class="form-control "
                                    style="width: 95% !important;"
                                    [(ngModel)]="category.name"
                                    
                                />
                             
                           
                            </div>
                            <button
                           
                         
                           (click)="saveCat(category);hideCatBtn =true;showCatBtn = false;category.name ='' "
                            class="previewbtn text-center btn "
                        >
                            Save
                       
                        </button>
                        <button
                        (click)="cancelCat();hideCatBtn =true;showExistCat = true;showCatBtn = false;"
                        class="cancelbtn text-center btn "
                        >
                        Cancel
                       
                        </button>
                         </div>

                      
<div class="d-flex"  *ngIf=" filteredRecords.length != 0">
 




    <div *ngIf="showExistCat" class="flex justify-content-center treeSel">
        <p-treeSelect
            class="w-full md:w-20rem"
            containerStyleClass="w-full"
            [(ngModel)]="selectedCategories"
            [options]="filteredRecords"
            display="chip"
            selectionMode="checkbox"
            placeholder="Select Item"
            [filter]="true"
            filterPlaceholder="Search Items"
            (onNodeSelect)="onNodeSelectCat($event)"
            (onNodeUnselect)="onNodeUnselectCat($event)"
        >
            <!-- Header Template to Create Space After the Search Filter -->
            <ng-template pTemplate="header">
                <!-- Empty Template to Reserve Space -->
            </ng-template>
    
            <!-- Custom First Option with Select All and Collapse All -->
            <ng-template let-node pTemplate="default">
                <!-- Check if it's the first custom node; render Select All / Collapse All -->
                <!-- <div *ngIf="node.key === 'customNode'" class="header p-2 d-flex align-items-center justify-content-between">
                    <a (click)="toggleSelectAll()">
                        Select All
                    </a>
                    <a class=" " (click)="collapseAll()">Collapse All</a>
                </div> -->
    
                <!-- Main Display for Other Nodes -->
                <div (click)="onLabelClick($event)" class="d-flex justify-content-between px-4">
                    <span style="margin-top: 8px;">{{ node.label }}</span>
                    <div class="treenode-action">
                        <div class="btn-group dropdown" dropdown container="body" placement="bottom right">
                            <button
                                title="actions"
                                class="dropdown-toggle btn btn-sm"
                                aria-controls="dropdown-alignment"
                                dropdownToggle
                            >
                                <div class="three-dots"></div>
                            </button>
                            <ul
                                id="dropdown-alignment"
                                class="dropdown-menu dropdown-action-btn dropdown-menu-right"
                                *dropdownMenu
                            >
                                <li>
                                    <a (click)="addAsNewChild(node); showCatBtn = true; showExistCat = false">
                                        <svg class="mx-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_83_2876)">
                                              <path d="M6.99984 13.3332C6.99984 13.5984 7.10519 13.8527 7.29273 14.0403C7.48027 14.2278 7.73462 14.3332 7.99984 14.3332C8.26505 14.3332 8.51941 14.2278 8.70694 14.0403C8.89448 13.8527 8.99984 13.5984 8.99984 13.3332V8.99984H13.3332C13.5984 8.99984 13.8527 8.89448 14.0403 8.70694C14.2278 8.51941 14.3332 8.26505 14.3332 7.99984C14.3332 7.73462 14.2278 7.48027 14.0403 7.29273C13.8527 7.10519 13.5984 6.99984 13.3332 6.99984H8.99984V2.6665C8.99984 2.40129 8.89448 2.14693 8.70694 1.9594C8.51941 1.77186 8.26505 1.6665 7.99984 1.6665C7.73462 1.6665 7.48027 1.77186 7.29273 1.9594C7.10519 2.14693 6.99984 2.40129 6.99984 2.6665V6.99984H2.6665C2.40129 6.99984 2.14693 7.10519 1.9594 7.29273C1.77186 7.48027 1.6665 7.73462 1.6665 7.99984C1.6665 8.26505 1.77186 8.51941 1.9594 8.70694C2.14693 8.89448 2.40129 8.99984 2.6665 8.99984H6.99984V13.3332Z" fill="#777777"/>
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_83_2876">
                                                <rect width="16" height="16" fill="white"/>
                                              </clipPath>
                                            </defs>
                                          </svg>               {{ "AddSubcategory" | localize }}
                                    </a>
                                </li>
                                <li>
                                    <a (click)="EditCat(node); showCatBtn = true; showExistCat = false">
                                        <svg class="mx-2" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                            <g clip-path="url(#clip0_83_2871)">
                                              <path d="M8.2749 2.66666H5.4749C4.3548 2.66666 3.79474 2.66666 3.36692 2.88464C2.9906 3.07639 2.68464 3.38235 2.49289 3.75867C2.2749 4.1865 2.2749 4.74655 2.2749 5.86666V11.4667C2.2749 12.5868 2.2749 13.1468 2.49289 13.5746C2.68464 13.951 2.9906 14.2569 3.36692 14.4487C3.79474 14.6667 4.3548 14.6667 5.4749 14.6667H11.0749C12.195 14.6667 12.7551 14.6667 13.1829 14.4487C13.5592 14.2569 13.8652 13.951 14.0569 13.5746C14.2749 13.1468 14.2749 12.5868 14.2749 11.4667V8.66666M6.27488 10.6667H7.39125C7.71737 10.6667 7.88043 10.6667 8.03388 10.6298C8.16993 10.5972 8.29999 10.5433 8.41928 10.4702C8.55384 10.3877 8.66914 10.2724 8.89974 10.0418L15.2749 3.66666C15.8272 3.11437 15.8272 2.21894 15.2749 1.66666C14.7226 1.11437 13.8272 1.11437 13.2749 1.66665L6.89973 8.04182C6.66912 8.27242 6.55382 8.38772 6.47137 8.52228C6.39826 8.64157 6.34439 8.77163 6.31172 8.90768C6.27488 9.06113 6.27488 9.22419 6.27488 9.55031V10.6667Z" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_83_2871">
                                                <rect width="16" height="16" fill="white" transform="translate(0.941406)"/>
                                              </clipPath>
                                            </defs>
                                          </svg>     {{ "Edit" | localize }}
                                    </a>
                                </li>
                                <li>
                                    <a (click)="deleteCat(node)">
                                        <svg class="mx-2" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <path d="M5.40909 2.33333H8.59091C8.59091 1.94656 8.4233 1.57563 8.12494 1.30214C7.82659 1.02865 7.42194 0.875 7 0.875C6.57806 0.875 6.17341 1.02865 5.87506 1.30214C5.5767 1.57563 5.40909 1.94656 5.40909 2.33333ZM4.45455 2.33333C4.45455 1.71449 4.72273 1.121 5.20009 0.683417C5.67746 0.245833 6.3249 0 7 0C7.6751 0 8.32254 0.245833 8.79991 0.683417C9.27727 1.121 9.54545 1.71449 9.54545 2.33333H13.5227C13.6493 2.33333 13.7707 2.37943 13.8602 2.46147C13.9497 2.54352 14 2.6548 14 2.77083C14 2.88687 13.9497 2.99815 13.8602 3.08019C13.7707 3.16224 13.6493 3.20833 13.5227 3.20833H12.6891L11.9146 11.7268C11.8583 12.3464 11.55 12.9241 11.0508 13.3452C10.5516 13.7662 9.89801 14 9.21964 14H4.78036C4.10199 14 3.44842 13.7662 2.94923 13.3452C2.45004 12.9241 2.14171 12.3464 2.08536 11.7268L1.31091 3.20833H0.477273C0.350692 3.20833 0.229296 3.16224 0.13979 3.08019C0.0502839 2.99815 0 2.88687 0 2.77083C0 2.6548 0.0502839 2.54352 0.13979 2.46147C0.229296 2.37943 0.350692 2.33333 0.477273 2.33333H4.45455ZM6.04545 5.6875C6.04545 5.57147 5.99517 5.46019 5.90566 5.37814C5.81616 5.29609 5.69476 5.25 5.56818 5.25C5.4416 5.25 5.32021 5.29609 5.2307 5.37814C5.14119 5.46019 5.09091 5.57147 5.09091 5.6875V10.6458C5.09091 10.7619 5.14119 10.8731 5.2307 10.9552C5.32021 11.0372 5.4416 11.0833 5.56818 11.0833C5.69476 11.0833 5.81616 11.0372 5.90566 10.9552C5.99517 10.8731 6.04545 10.7619 6.04545 10.6458V5.6875ZM8.43182 5.25C8.30524 5.25 8.18384 5.29609 8.09434 5.37814C8.00483 5.46019 7.95455 5.57147 7.95455 5.6875V10.6458C7.95455 10.7619 8.00483 10.8731 8.09434 10.9552C8.18384 11.0372 8.30524 11.0833 8.43182 11.0833C8.5584 11.0833 8.6798 11.0372 8.7693 10.9552C8.85881 10.8731 8.90909 10.7619 8.90909 10.6458V5.6875C8.90909 5.57147 8.85881 5.46019 8.7693 5.37814C8.6798 5.29609 8.5584 5.25 8.43182 5.25Z" fill="#777777"/>
                                          </svg>    {{ "Delete" | localize }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </ng-template>
    
            <!-- Footer Template -->
            <ng-template pTemplate="footer">
                <div class="d-flex justify-content-end p-2">
                    <button class="btn bgPurple" (click)="saveSelection()">Save</button>
                    <button class="btn btn-secondary" (click)="cancelSelection()">Cancel</button>
                </div>
            </ng-template>
        </p-treeSelect>
    </div>
    

                  
                        <button *ngIf="showExistCat " (click)="showCatBtn = true;showExistCat = false ; toggleAppCatCodes()" class="d-flex p-y-1 px-4 rounded cat"> <span class="mr-2">+</span> Add New Categories</button>
                    </div>
                    </div>
                    <div *ngIf="!createOrEditorderInfo">
                        <div
                            class="categoriesClassificationsContainer d-flex align-items-center big-scroll   row   w-100"
                        >
                            <h6 class="previewTitle  m-0 p-0 pr-2">Categories :</h6>
                            <p
                                class="previewValue classificationsValues  m-0 p-0  my-2"
                                *ngFor="
                                    let item of appTransactionsForViewDto?.entityCategoriesNames?.items
                                "
                            >
                                {{ item}}
                            </p>

                    
                            <p
                                class="previewValue   m-0 p-0 col-6 my-2"
                                *ngIf="
                                !appTransactionsForViewDto?.entityCategoriesNames  || appTransactionsForViewDto?.entityCategoriesNames?.items.length == 0
                            "
                            >
                                -
                            </p>
                        </div>
                    </div>
                </div>
                <!-- categories -->

                <!-- dates -->
                <div class="col-md-6 mt-2 position-relative dates">
                    <div *ngIf="createOrEditorderInfo">
                        <label class="label">Entered Date</label>
                        <div class="">
                            <p-calendar
                            #calendar1
                            appendTo="body"
                                [(ngModel)]="enteredDate"
                                [showIcon]="true"
                                (ngModelChange)="onChangeDate()"
                                [showOtherMonths]="true"
                                [selectOtherMonths]="true"
                            ></p-calendar>
                           
                        <img src="../../../../../assets/icons/calendar.png"  style="cursor: pointer;" (click)="openCalendar(calendar1)"    alt="" srcset="">

                        </div>
                    </div>
                    <div *ngIf="!createOrEditorderInfo">
                        <div
                            class="d-flex align-items-center   w-100"
                        >
                            <h6 class="previewTitle  m-0 p-0 col-6 my-2">Entered Date :</h6>
                            <p class="previewValue  m-0 p-0 col-6 my-2">
                                {{ appTransactionsForViewDto?.enteredDate?.toString() | date : "MM/dd/yyyy  " }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mt-2 position-relative dates">
                    <div *ngIf="createOrEditorderInfo">
                        <label class="label">Start Date</label>
                        <p-calendar
                        #calendar2
                        appendTo="body"
                            [(ngModel)]="startDate"
                            [showIcon]="true"
                            (ngModelChange)="onChangeDate()"
                            [showOtherMonths]="true"
                            [selectOtherMonths]="true"
                        ></p-calendar>
                        <img src="../../../../../assets/icons/calendar.png"  style="cursor: pointer;" (click)="openCalendar(calendar2)"   alt="" srcset="">

                    </div>
                    <div *ngIf="!createOrEditorderInfo">
                        <div
                            class="d-flex align-items-center   w-100"
                        >
                            <h6 class="previewTitle  m-0 p-0 col-6 my-2">Start Date :</h6>
                            <p class="previewValue  m-0 p-0 col-6 my-2">
                                {{ appTransactionsForViewDto?.startDate?.toString() | date : "MM/dd/yyyy "}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mt-2 position-relative dates">
                    <div *ngIf="createOrEditorderInfo">
                        <label class="label">Available Date</label>
                        <p-calendar
                        #calendar3
                        appendTo="body"
                            [(ngModel)]="availableDate"
                            [showIcon]="true"
                            (ngModelChange)="onChangeDate()"
                            [minDate]="startDate"
                            [showOtherMonths]="true"
                            [selectOtherMonths]="true"
                        ></p-calendar>
                        <img src="../../../../../assets/icons/calendar.png"  style="cursor: pointer;" (click)="openCalendar(calendar3)"  alt="" srcset="">

                    </div>
                    <div *ngIf="!createOrEditorderInfo">
                        <div
                            class="d-flex align-items-center   w-100"
                        >
                            <h6 class="previewTitle  m-0 p-0 col-6 my-2">
                                Avaialable Date :
                            </h6>
                            <p class="previewValue  m-0 p-0 col-6 my-2">
                                {{ appTransactionsForViewDto?.availableDate?.toString() | date : "MM/dd/yyyy " }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mt-2 position-relative dates">
                    <div *ngIf="createOrEditorderInfo">
                        <label class="label">Complete Date</label>
                        <p-calendar
                        #calendar4
                        appendTo="body"
                            [(ngModel)]="completeDate"
                            [showIcon]="true"
                            (onSelect)="changeCompleteDate(completeDate)"
                            (ngModelChange)="changeCompleteDate(completeDate)"
                            [minDate]="availableDate"
                            [showOtherMonths]="true"
                            [selectOtherMonths]="true"
                        ></p-calendar>
                        <img src="../../../../../assets/icons/calendar.png" style="cursor: pointer;" (click)="openCalendar(calendar4)"  alt="" srcset="">

                    </div>
                    <div *ngIf="!createOrEditorderInfo">
                        <div
                            class="d-flex align-items-center   w-100"
                        >
                            <h6 class="previewTitle  m-0 p-0 col-6 my-2">
                                Complete Date :
                            </h6>
                            <p class="previewValue  m-0 p-0 col-6 my-2">
                                {{ appTransactionsForViewDto?.completeDate?.toString() | date : "MM/dd/yyyy " }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- dates -->
              
                <!-- currency -->
                <div class="col-md-6 mt-2">
                    <div *ngIf="createOrEditorderInfo">
                        <label class="label">Currency</label>
                        <p-dropdown
                            [options]="currencies"
                            [(ngModel)]="selectedCurrency"
                            optionLabel="code"
                            optionValue="value"
                            class="w-100"
                            (onChange)="onchangeCurrency()"
                        ></p-dropdown>
                    </div>
                    <div *ngIf="!createOrEditorderInfo">
                        <div
                            class="d-flex align-items-center  "
                        >
                            <h6 class="previewTitle  m-0 p-0 col-6  my-2">Currency :</h6>
                            <p class="previewValue  m-0 p-0 col-6 my-2">
                                {{ appTransactionsForViewDto?.currencyCode }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- currency -->

                <!-- exchange rate -->
                <div class="col-md-6 mt-2">
                    <div *ngIf="createOrEditorderInfo" class="formGroup">
                        <label class="label">Exchange Rate</label>
                        <input
                        [readonly]="appTransactionsForViewDto?.currencyExchangeRate && appTransactionsForViewDto?.currencyExchangeRate >0"
                            type="text"
                            placeholder="Exchange Rate..."
                            class="form-control w-100"
                            [(ngModel)]="appTransactionsForViewDto.currencyExchangeRate"
                        />
                    </div>
                    <div *ngIf="!createOrEditorderInfo">
                        <div
                            class="d-flex align-items-center   w-100"
                        >
                            <h6 class="previewTitle  m-0 p-0 col-6 my-2">
                                Exchange Rate :
                            </h6>
                            <p class="previewValue  m-0 p-0 col-6  my-2">
                                {{ appTransactionsForViewDto?.currencyExchangeRate }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- exchange rate -->
            </div>
        </div>
        <hr class="my-2" />
        <div class="d-flex justify-content-end pr-3">
            <button
            [disabled]="!(isContactsValid && isSalesOrderValidForm())"
            *ngIf="createOrEditorderInfo && !showSaveBtn"
            (click)="createOrEditTransaction()"
            class="continuebtn text-center btn float-right"
        >
            Continue
        </button>
 
<button
*ngIf="showSaveBtn"
(click)="cancel()"
class="cancelbtn text-center btn float-right"
>
Cancel
</button>
<button
*ngIf="showSaveBtn"
[disabled]="!(isContactsValid && isSalesOrderValidForm())"
(click)="save()"
class="previewbtn text-center btn float-right"
>
Save
</button>
</div>
    </div>
</div>


<!-- <p-dialog [(visible)]="visible " [modal]="true" [style]="{ width: '474px' }" [draggable]="false" >

    <div class=" con-body">
      <p class="mb-3">
        <svg class="mb-2" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.168 4.446C1.31469 4.22511 1.54311 4.07152 1.80302 4.01901C2.06294 3.9665 2.33306 4.01938 2.554 4.166L5.554 6.168C5.76621 6.31847 5.91143 6.54571 5.95884 6.80149C6.00625 7.05727 5.95213 7.32146 5.80795 7.53799C5.66377 7.75451 5.44089 7.90634 5.18661 7.96123C4.93233 8.01612 4.66666 7.96977 4.446 7.832L1.446 5.832C1.22543 5.685 1.07225 5.45643 1.02012 5.19654C0.967996 4.93665 1.02118 4.6667 1.168 4.446ZM16 4C13.6131 4 11.3239 4.94821 9.63604 6.63604C7.94821 8.32387 7 10.6131 7 13V17.802L5.072 22.628C5.01119 22.7797 4.98851 22.944 5.00593 23.1066C5.02335 23.2691 5.08034 23.4249 5.17192 23.5603C5.26349 23.6957 5.38686 23.8065 5.53123 23.8832C5.67559 23.9599 5.83654 24 6 24H26C26.1632 23.9998 26.3239 23.9597 26.468 23.8832C26.6122 23.8066 26.7354 23.6959 26.8269 23.5608C26.9184 23.4257 26.9755 23.2702 26.9931 23.108C27.0107 22.9457 26.9884 22.7816 26.928 22.63L25 17.8V13C25 10.6131 24.0518 8.32387 22.364 6.63604C20.6761 4.94821 18.3869 4 16 4ZM16 29C15.113 29.0002 14.2512 28.7056 13.5499 28.1626C12.8486 27.6195 12.3477 26.8588 12.126 26H19.874C19.6523 26.8588 19.1514 27.6195 18.4501 28.1626C17.7488 28.7056 16.887 29.0002 16 29ZM29.446 4.168C29.6667 4.03023 29.9323 3.98388 30.1866 4.03877C30.4409 4.09367 30.6638 4.24549 30.8079 4.46202C30.9521 4.67854 31.0063 4.94273 30.9588 5.19852C30.9114 5.4543 30.7662 5.68153 30.554 5.832L27.554 7.832C27.3333 7.96977 27.0677 8.01612 26.8134 7.96123C26.5591 7.90634 26.3362 7.75451 26.1921 7.53799C26.0479 7.32146 25.9937 7.05727 26.0412 6.80149C26.0886 6.54571 26.2338 6.31847 26.446 6.168L29.446 4.168ZM0 13C0 12.7348 0.105357 12.4804 0.292893 12.2929C0.48043 12.1054 0.734784 12 1 12H4C4.26522 12 4.51957 12.1054 4.70711 12.2929C4.89464 12.4804 5 12.7348 5 13C5 13.2652 4.89464 13.5196 4.70711 13.7071C4.51957 13.8946 4.26522 14 4 14H1C0.734784 14 0.48043 13.8946 0.292893 13.7071C0.105357 13.5196 0 13.2652 0 13ZM31 12C31.2652 12 31.5196 12.1054 31.7071 12.2929C31.8946 12.4804 32 12.7348 32 13C32 13.2652 31.8946 13.5196 31.7071 13.7071C31.5196 13.8946 31.2652 14 31 14H28C27.7348 14 27.4804 13.8946 27.2929 13.7071C27.1054 13.5196 27 13.2652 27 13C27 12.7348 27.1054 12.4804 27.2929 12.2929C27.4804 12.1054 27.7348 12 28 12H31Z" fill="#F6851D"/>
            </svg> 
            
            <span *ngIf="cancelBtn" class="msg-text ml-2">Your changes Discarded Successfuly </span>
            <span *ngIf="saveBtn" class="msg-text ml-2">Are you sure you want to save changes you made ?</span>
    </p>

    </div>
  
  
    <div *ngIf="cancelBtn" class="d-flex justify-content-center btns" >
    
      <button  (click)="visible = false;cancel()" label="Ok" Class="p-button-text">Ok</button>
      <button  (click)="visible = false;SuccessMsg = true ;cancel()" label="Yes" class="p-button-text" >Yes</button>
    </div>

    <div *ngIf="saveBtn" class="d-flex justify-content-center btns" >
    
        <button  (click)="visible = false ;"  label="No" Class="p-button-no">No</button>
        <button  (click)="save();visible = false" label="Yes" class="p-button-text" >Yes</button>
      </div>
  </p-dialog>


  <p-dialog [(visible)]="SuccessMsg" [modal]="true" [style]="{ width: '474px' }" [draggable]="false" >
<div class="d-flex justify-content-center img-hd m-auto">
    <img src="../../../../../assets/icons/success-Purble.svg">

</div>
    <div class=" con-body">

      <p class="mb-3 text-center">
            
            <span *ngIf="cancelBtn" class="msg-text ml-2 ">Changes discarded successfuly</span>
            <span *ngIf="saveBtn" class="msg-text ml-2 ">Changes saved successfuly</span>
    </p>

    </div>
  
  
    <div class="d-flex justify-content-center btns" >
    
 
      <button  (click)="SuccessMsg = false" label="Ok" class="p-button-text" >Ok</button>
    </div>
  </p-dialog> -->